import React from "react";
import { Button, Modal } from "react-bootstrap";
import { injectIntl } from "react-intl";

function SubmitPostDialog({
  show,
  onHide,
  post,
  handleSubmit,
  dataschedule,
  dateLabelLocal,
  dateLabelUTC,
  editPost,
}) {
  const onSubmit = () => {
    handleSubmit(post);
    onHide();
  };

  return (
    <>
      <Modal size="lg" show={show} onHide={onHide}>
        <Modal.Header>
          {!dataschedule && !editPost && (
            <div>
              Since there's no Schedule Date set, the Post will be published
              right away. Are you sure you want to publish now?
            </div>
          )}
          {dataschedule && !editPost && (
            <div>
              According to the Schedule Date set, this Post will be published on{" "}
              {dateLabelUTC}, {dateLabelLocal}. Are you sure you want to
              schedule?
            </div>
          )}
          {dataschedule && editPost && (
            <div>
              According to the Schedule Date set, this Post will be edited on{" "}
              {dateLabelUTC}, {dateLabelLocal}. Are you sure you want to
              schedule?
            </div>
          )}
          {!dataschedule && editPost && (
            <div>
              Since there's no Schedule Date set, the Post will be edited and
              published right away. Are you sure you want to publish now?
            </div>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-end">
            <div className="mr-2">
              <Button onClick={() => onHide()}>Cancel</Button>
            </div>
            <div>
              <Button onClick={() => onSubmit()}>Yes, publish it</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default injectIntl(SubmitPostDialog);
